const routes = [
    {
        path: "/ticket/event",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "ticketevent_index"
        }
    }
];

export default routes;
